import { render } from "./KanbanBoard.vue?vue&type=template&id=ff4ddb3e&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=js"
export * from "./KanbanBoard.vue?vue&type=script&lang=js"

import "./KanbanBoard.vue?vue&type=style&index=0&id=ff4ddb3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4ddb3e"]])

export default __exports__